module.exports = __webpack_public_path__ + "static/media/toggle-up.3a23e107.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/toggle-up.svg
// module id = 692
// module chunks = 0